import React, { ReactElement } from 'react'
import styled from 'styled-components'

import { InfoIcon } from '../../lib/icons/info-icon'

export const bp_md = '992px'
export const ModalHeader = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
`

export const ModalFlex = styled.div`
    display: flex;
    gap: 25px;

    &.right {
        justify-content: flex-end;
    }

    &.space {
        justify-content: space-between;

        @media only screen and (max-width: ${bp_md}) {
            flex-direction: column;
        }
    }
`
export const ModalTitle = styled.div`
    font-weight: 500;
    font-size: 16px;
    color: #000000;
`
export const ModalSubtitle = styled.div`
    font-size: 16px;
    color: #000000;
    margin-bottom: 8px;

    &.sm {
        font-size: 14px;
    }
`
export const ModalContent = styled.div`
    padding: 35px 25px;
    width: 100%;
`
export const Input = styled.input`
    display: block;
    width: 160px;
    padding: 4px;
    border: 1px solid #b3b3b3;
    border-radius: 4px;

    @media only screen and (max-width: ${bp_md}) {
        width: 100%;
        height: 34px;
    }
`
export const Label = styled.label`
    display: block;
    margin-bottom: 6px;
    font-weight: 400;
`
export const Select = styled.select`
    display: block;
    width: 160px;
    padding: 4px;
    border: 1px solid #b3b3b3;
    border-radius: 4px;
    background-color: #ffffff;
    font-family: ${({ theme }) => theme.font.name};

    &.disabled {
        background-color: #d0d0ce;
        -moz-appearance: none;
        -webkit-appearance: none;
    }

    @media only screen and (max-width: ${bp_md}) {
        width: 100%;
        height: 34px;
    }
`

export const ConnectorSettings = styled.div`
    margin-top: 24px;
    width: 320px;

    @media only screen and (max-width: ${bp_md}) {
        width: 290px;
        margin-top: 4px;
    }
`
const Tooltip = styled.div`
    display: inline-block;
    margin-left: 4px;
`

export const TooltipIcon = ({ className, title }: { className?: string; title?: string }): ReactElement => (
    <Tooltip className={className}>
        <InfoIcon title={title} />
    </Tooltip>
)

export const ErrorMsg = styled.div`
    width: 100%;
    min-height: 40px;
    font-weight: 400;
    margin-top: 4px;
    color: #dd0000;

    &.marginLeft {
        margin-left: 20px;
    }
`

export const SRedirectLink = styled.a`
    color: ${({ theme }) => theme.brandColors.CA_Blue};
    margin-left: 4px;
    padding: 0px 6px;

    &:hover {
        cursor: pointer;
        text-decoration: none;
        color: ${({ theme }) => theme.brandColors.CA_Blue};
        opacity: 0.5;
    }
    &:active {
        text-decoration: none;
        color: ${({ theme }) => theme.brandColors.CA_Blue};
    }
    &[disabled] {
        cursor: not-allowed;
        opacity: 0.5;
    }
`

export const SDisabledText = styled.span`
    color: ${({ theme }) => theme.brandColors.CA_Blue};

    cursor: not-allowed;
    opacity: 0.5;
`
